import { useReactiveSelectQuery } from "@/models/hooks/useReactiveSelectQuery.ts";
import { feedPermissions, fetchFeedPermissions } from "@/models/repositories";

export type InvalidFeedPermissionsReturn = "Loading" | "NoRightsToViewContentModal" | "Feed";
export const invalidFeedPermissions = ({
  workspaceMembershipId,
  feedId,
}: {
  workspaceMembershipId: string;
  feedId: string;
}): InvalidFeedPermissionsReturn => {
  const feedPermissionCount =
    useReactiveSelectQuery(feedPermissions, [feedId], "queryTransformers.hasFeedPermissions") ?? [];
  const hasLoadedFeedPermissions = feedPermissionCount.length > 0;

  const feedPermissionsResult =
    useReactiveSelectQuery(
      fetchFeedPermissions,
      [
        {
          workspaceMembershipId,
          feedId,
        },
      ],
      "queryTransformers.fetchFeedPermissions",
    ) ?? [];

  if (!hasLoadedFeedPermissions) {
    return "Loading";
  }

  const noAccess = feedPermissionsResult.filter((perm) => perm.enabled === false && perm.name === "read")?.length > 0;
  const filtered = feedPermissionsResult.filter((perm) => perm.enabled);
  const fullAccess = filtered.some((perm) => perm.name === "admin");

  if (noAccess || (hasLoadedFeedPermissions && filtered?.length === 0)) {
    return "NoRightsToViewContentModal";
  } else if (fullAccess) {
    return "Feed";
  } else if (filtered?.length === 0) {
    return "Loading";
  }
  return filtered?.length > 0 ? "Feed" : "NoRightsToViewContentModal";
};
